import {
  SeedClass,
  SeedClassDTO,
  SeedClassListRequestFilter,
  SeedClassListRequestSorting,
} from 'modules/domain/seedClass/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const getSeedClassesList = (
  filter: SeedClassListRequestFilter,
  sorting: SeedClassListRequestSorting,
  page: number,
  pageSize?: number,
) => {
  try {
    return apiClient.get<ListResponse<SeedClass>>(endpoints.seedClass(), {
      ...filter,
      ...sorting,
      page: page,
      page_size: pageSize,
    })
  } catch (err) {
    console.error('Seed classes list fetch error!', err)
    throw err
  }
}

export const getSeedClass = (id: string) => {
  try {
    return apiClient.get<SeedClass>(endpoints.seedClass(id))
  } catch (err) {
    console.error('Seed class fetch error!', err)
    throw err
  }
}

export const addSeedClass = (seedClass: SeedClassDTO) => {
  try {
    return apiClient.post<SeedClass>(endpoints.seedClass(), seedClass)
  } catch (err) {
    console.error('Seed class create error!', err)
    throw err
  }
}

export const updateSeedClass = (id: string, seedClass: SeedClassDTO) => {
  return apiClient.put<SeedClass>(endpoints.seedClass(id), seedClass)
}

export const removeSeedClass = (id: string) => {
  return apiClient.delete(endpoints.seedClass(id))
}
